import { render, staticRenderFns } from "./TipoLibroPage.vue?vue&type=template&id=794eb776"
import script from "./TipoLibroPage.js?vue&type=script&lang=js&external"
export * from "./TipoLibroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports